const { createContext } = require("react");




const EditableContext = createContext(null);


export default EditableContext;